import { XCircleIcon } from '@heroicons/react/20/solid';
import React from 'react';
import GroupRadio from './GroupRadio';
export type Answer = {
  id: unknown;
  label: string;
  selected?: boolean;
};
export type Question = {
  url: string;
  id: number;
  answer: Answer[];
};

type OnchangeInputArgs = { questionId: number; optionId: number };

export interface MatchingElementsProps {
  questions: Question[];
  onChangeInput?: (args: OnchangeInputArgs) => void;
  onDelete?: (args: Pick<OnchangeInputArgs, 'questionId'>) => void;
}

export function MatchingElements({
  questions,
  onChangeInput,
  onDelete,
}: MatchingElementsProps) {
  return (
    <div className="grid grid-cols-3 gap-2">
      {React.Children.toArray(
        questions?.map((element, i) => (
          <fieldset className="flex relative rounded-lg justify-center items-center gap-10 flex-wrap px-6 py-4 border border-x-gray-100 border-b-gray-100">
            {onDelete ? (
              <button
                onClick={() => {
                  onDelete({ questionId: element.id });
                }}
                className="absolute top-4 right-4"
              >
                <XCircleIcon
                  className="h-5 w-5 text-red-500 hover:text-red-600 transition"
                  aria-hidden="true"
                />
              </button>
            ) : null}
            <img src={element.url} className="w-24" />
            <div className="space-y-1">
              <GroupRadio
                options={element.answer}
                onChange={() => (option: typeof element.answer[number]) => {
                  onChangeInput?.({
                    optionId: option.id as number,
                    questionId: element.id,
                  });
                }}
              />
            </div>
          </fieldset>
        ))
      )}
    </div>
  );
}

export default MatchingElements;
